export default {"src":"https://cloudflare.edhrec.com/_next/static/media/manau.d78a33b3.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};